import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {ProductFaceDefaultPlacement as Entity} from "./product-face-default-placement.model";
import {IPageInfo, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";


export interface ProductFaceDefaultPlacementState extends EntityState<Entity> {
  entities: { [id: number]: Entity };
  ids: number[];
  isLoading: boolean;
  error: Error | undefined;
  currentPage: IPageInfo;
  currentSort: ITableSort | undefined;
  currentEntityId: number | undefined,
  history: { correlationId: string, payload: Entity | Entity[] | number | number[] | IResultWithPageInfo<Entity> }[];
}

export const productFaceDefaultPlacementEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>(
  {
    selectId: (defaultPlacement: Entity) => defaultPlacement.id
  }
);

export const initialState: ProductFaceDefaultPlacementState = productFaceDefaultPlacementEntityAdapter.getInitialState({
  entities: [],
  ids: [],
  isLoading: false,
  error: undefined,
  currentPage: { page: { pageNumber: 0, pageSize: 25 }, totalCount: 0},
  currentSort: undefined,
  currentEntityId: undefined,
  history: []
});
